<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Self Appraisal Parameter</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row justify="center" align="center">
        <tr class="t-row">
          <div>
            <th>
              <v-row>
                <span v-for="header in headers" :key="header.text">
                  <span v-if="filters.hasOwnProperty(header.value)">
                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                      color="#0F2027" :label="header.text" multiple clearable :items="columnValueList(header.value)"
                      v-model="filters[header.value]"></v-autocomplete>
                  </span>
                </span>
              </v-row>
            </th>
          </div>
        </tr>
      </v-row>
      <v-data-table :headers="headers" :items="bookList1" class="elevation-1 mytable" dense :search="search">
        <template v-slot:top>
          <v-toolbar flat dense color="white">
            <!-- <v-toolbar-title>Fees Component</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider> -->
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
            </v-text-field>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on }">
                <v-btn class="button" v-on="on">Add Parameter</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="6" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="ay_list" item-text="academicyear"
                          item-value="ay_id" v-model="addedItem.academicyear"
                          label="Select Academic Year"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" v-if="editedIndex != -1">
                        <v-autocomplete dense rounded outlined :items="ay_list" item-text="academicyear"
                          v-model="editedItem.academicyear" label="Select Academic Year"></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="6" md="6" v-if="editedIndex == -1">
                        <v-autocomplete dense rounded outlined :items="parameter_number_list"
                          v-model="addedItem.parameter_no" label="Select Parameter Number"></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" v-if="editedIndex != -1">
                        <v-autocomplete dense rounded outlined :items="parameter_number_list"
                          v-model="editedItem.parameter_no" label="Select Parameter Number"></v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-text-field v-model="addedItem.parameter_display_no" dense rounded outlined persistent-hint
                          :disabled="editedIndex != -1" hint="For example 1,2.."
                          label="Parameter No. Display Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.parameter_display_no" dense rounded outlined persistent-hint
                          hint="For example 1,2.." label="Parameter No. Display Name"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-text-field v-model="addedItem.parameter_name" dense rounded outlined persistent-hint
                          hint="For example 1,2.." label="Parameter Name"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.parameter_name" dense rounded outlined persistent-hint
                          hint="For example 1,2.." label="Parameter Name"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                        <v-text-field v-model="addedItem.parameter_weightage" dense rounded type="number" outlined
                          persistent-hint hint="For example 10,20.." label="Parameter Weightage"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                        <v-text-field v-model="editedItem.parameter_weightage" dense rounded type="number" outlined
                          persistent-hint hint="For example 10,20.." label="Parameter Weightage"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <!-- <template class="pb-5">
          <v-row justify="center" align="center">
            <tr class="t-row">
              <div>
                <th>
                  <v-row>
                    <span v-for="header in headers" :key="header.text">
                      <span v-if="filters.hasOwnProperty(header.value)">
                        <v-autocomplete
                          class="mr-2 pb-5 pt-2"
                          flat
                          hide-details
                          small
                          rounded
                          dense
                          outlined
                          color="#0F2027"
                          :label="header.text"
                          multiple
                          clearable
                          :items="columnValueList(header.value)"
                          v-model="filters[header.value]"
                        ></v-autocomplete>
                      </span>
                    </span>
                  </v-row>
                </th>
              </div>
            </tr>
          </v-row>
        </template> -->

        <!-- <template v-slot:item.compulsory="{ item }">
          <v-switch
            inset
            v-model="item.compulsory"
            :color="item.compulsory ? 'success' : 'primary'"
            @change="toggle(item)"
          ></v-switch>
        </template> -->

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    overlay: false,
    errorMsg: {
      academicyear: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    ay_list: null,
    // extraBreadcrumbItems: [
    //   { text: "Appraisal Parameter", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    headers: [
      {
        text: "Sr. No.",
        align: "left",
        sortable: false,
        value: "srno",
      },
      {
        text: "Academic Year",
        align: "left",
        sortable: true,
        value: "academicyear",
      },
      {
        text: "Parameter No.",
        align: "left",
        sortable: true,
        value: "parameter_no",
      },
      {
        text: "Display No.",
        align: "left",
        sortable: true,
        value: "parameter_display_no",
      },
      {
        text: "Parameter Name",
        align: "left",
        sortable: true,
        value: "parameter_name",
      },
      {
        text: "Parameter Weightage",
        align: "left",
        sortable: true,
        value: "parameter_weightage",
      },
      {
        text: "Isactive",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    filters: {
      academicyear: [],
      parameter_name: [],
      parameter_no: [],
    },
    self_appriasal_parameter_list: [],
    parameter_number_list: [],
    editedIndex: -1,
    addedItem: {
      academicyear: null,
      parameter_no: null,
      parameter_display_no: null,
      parameter_name: null,
      parameter_weightage: 0,
    },
    editedItem: {
      id: "",
      academicyear: null,
      parameter_no: null,
      parameter_display_no: null,
      parameter_name: null,
      parameter_weightage: 0,
      isactive: true,
    },
    defaultItem: {
      id: "",
      academicyear: null,
      parameter_no: null,
      parameter_display_no: null,
      parameter_name: null,
      parameter_weightage: 0,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Appraisal Parameter"
        : "Edit Appraisal Parameter";
    },
    bookList1() {
      return this.self_appriasal_parameter_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    columnValueList(val) {
      return this.self_appriasal_parameter_list.map((d) => d[val]);
    },
    initializeErrorMsgFalse() {
      this.errorMsg.academicyear = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/SelfAppriasalMaster/appriasalParameter")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.ay_list = res.data.ay_list;
            this.self_appriasal_parameter_list =
              res.data.self_appriasal_parameter_list;
            this.parameter_number_list = res.data.parameter_number_list;
            this.load = true;
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.self_appriasal_parameter_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post(
              "/SelfAppriasalMaster/editappriasalParameter",
              this.editedItem
            )
            .then((res) => {
              if (res.data.flag == "YES") {
                this.showSnackbar("#4caf50", res.data.snackabar); // show snackbar on success
              } else {
                this.showSnackbar("#b71c1c", res.data.snackabar);
              }
              this.onLoad();
            })
            .catch((error) => {
              window.console.log(error);
              this.showSnackbar("#b71c1c", "Something went wrong!!!");
            })
            .finally(() => {});

          this.close();
        }
      } else {
        if (this.addedItem.academicyear == null) {
          this.showSnackbar("#b71c1c", "Please select Academic Year!!!");
          return false;
        }
        if (this.addedItem.parameter_no == null) {
          this.showSnackbar("#b71c1c", "Please select Parameter Number!!!");
          return false;
        }
        if (
          this.addedItem.parameter_name == null ||
          this.hasWhiteSpace(this.addedItem.parameter_name)
        ) {
          this.showSnackbar("#b71c1c", "Please enter Parameter Name!!!");
          return false;
        }
        if (
          this.addedItem.parameter_display_no == null ||
          this.hasWhiteSpace(this.addedItem.parameter_display_no)
        ) {
          this.showSnackbar("#b71c1c", "Please enter Parameter Display No.!!!");
          return false;
        }
        axios
          .post("/SelfAppriasalMaster/saveappriasalParameter", this.addedItem)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.self_appriasal_parameter_list.push(this.addedItem);
              this.showSnackbar("#4caf50", res.data.snackabar); // show snackbar on success
              this.onLoad();
              this.close();
              this.addedItem.academicyear = null;
              this.addedItem.parameter_no = null;
              this.addedItem.parameter_display_no = null;
              this.addedItem.parameter_name = null;
              this.addedItem.parameter_weightage = 0;
            } else if (res.data.flag == "NO") {
              this.showSnackbar("#b71c1c", res.data.snackabar); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {});
      }
    }, // end of save()

    makeLast(item) {
      if (confirm("Are you sure!")) {
        const formData = {
          id: item.id,
          islast: item.islast,
        };
        axios
          .post("/SelfAppriasalMaster/makeAuthorityLast", formData)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("#4caf50", res.data.snackabar); // show snackbar on success
              this.onLoad();
            } else if (res.data.flag == "NO") {
              this.showSnackbar("#b71c1c", res.data.snackabar); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          })
          .finally(() => {
            this.addedItem.authority_type = null;
          });
      }
    },
    hasWhiteSpace(s) {
      var status = false;
      var reWhiteSpace = new RegExp(/^\s+$/);

      // Check for white space
      if (reWhiteSpace.test(s)) {
        // alert("Please Check Your Fields For Spaces");
        return true;
      }
      return false;
    },

    isValidated() {
      if (this.editedItem.academicyear) {
        return true;
      } else {
        if (!this.editedItem.academicyear) {
          this.errorMsg.academicyear = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>
